import { List, ListItem, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import dataAtIds from '../../dataAtIds.json';
import ComingSoon from '../ComingSoon/ComingSoon';
import Page from '../Page/Page';
import PageBody from '../Page/PageBody';

const Crashes: FunctionComponent = () => (
  <Page>
    <PageBody alignChildren="middle">
      <ComingSoon data-trace-at-id={dataAtIds.CrashListPage}>
        <Text margin="x4" weight="bold">
          Catch bugs before they reach production — get detailed crash reports and monitor how your
          app is performing across the entire install base. When issues are detected we show you
          exactly what happened during the user session to locate, reproduce, and fix the problem as
          quickly as possible.
        </Text>

        <Text margin="x4">
          <Text margin="x2" weight="bold">
            Use Trace to:
          </Text>
          <List>
            <ListItem>
              <Text inline weight="bold">
                Detect the problem:
              </Text>{' '}
              Know about issues before your users report them.
            </ListItem>
            <ListItem>
              <Text inline weight="bold">
                Assess the impact:
              </Text>{' '}
              Focus on resolving the issues which are most impactful to your users.
            </ListItem>
            <ListItem>
              <Text inline weight="bold">
                Trace the cause:
              </Text>{' '}
              Spend less time trying to reproduce issues.
            </ListItem>
          </List>
        </Text>
      </ComingSoon>
    </PageBody>
  </Page>
);

export default Crashes;
